module.exports = "build/assets/news.a2490ab1.png";